import { createElementIdSlice } from '../utils/action/createElementSlice';
export const PromptContainerState = createElementIdSlice({
    elementName: 'prompt-container',
    initialState: {},
    reducers: {
        setOpen(state, action) {
            const isOpen = action.payload.data;
            if (!state || state.isOpen === isOpen) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { isOpen });
        },
        toggleOpen(state) {
            if (!state)
                return state;
            return Object.assign(Object.assign({}, state), { isOpen: !state.isOpen });
        },
        notifyApplyChanges(state) {
            // Controller update handled in loader
            return state;
        },
        notifyCancelChanges(state) {
            // Controller update handled in loader
            return state;
        },
    },
});
